export default {
  confirmDelete: '確定要刪除嗎？此操作不可復原',
  confirmLogout: '確定要登出嗎？',
  saveSuccess: '儲存成功',
  saveFailed: '儲存失敗',
  deleteSuccess: '刪除成功',
  deleteFailed: '刪除失敗',
  updateSuccess: '更新成功',
  updateFailed: '更新失敗',
  networkError: '網路錯誤，請稍後重試',
  serverError: '伺服器錯誤，請稍後重試',
  timeout: '請求逾時，請稍後重試',
  addSuccess: '新增成功',
  editSuccess: '編輯成功',
  actionSuccess: '操作成功',
  actionFailed: '操作失敗',
  fetchFailed: '取得資料失敗',
  pleaseSelectProduct: '請選擇產品',
};
